(function () {
  // One urgency message is chosen per browser SESSION (sessionStorage), not per
  // page load — so a visitor sees the same line across every product page /
  // refresh within a session, and a new session can land on a different one.
  var STORAGE_KEY = 'ww_urgency_message';

  function sessionStorageAvailable() {
    try {
      var k = '__ww_test__';
      window.sessionStorage.setItem(k, '1');
      window.sessionStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  function renderMessage(el, message) {
    if (!el || !message) return;
    if (/hurry!/i.test(message)) {
      el.innerHTML = message.replace(/hurry!/i, '<strong>Hurry!</strong>');
    } else {
      el.textContent = message;
    }
  }

  function initBoost(root) {
    var sid = root.id.replace('ww-conv-boost-', '');
    var textEl = document.getElementById('ww-cb-urgency-text-' + sid);
    var poolScript = document.getElementById('ww-cb-messages-' + sid);
    if (!textEl || !poolScript) return;

    var pool;
    try {
      pool = JSON.parse(poolScript.textContent);
    } catch (e) {
      pool = [];
    }
    pool = pool.filter(function (m) { return typeof m === 'string' && m.trim().length > 0; });
    // Empty pool: the server-rendered fallback text already stands, nothing to do.
    if (!pool.length) return;

    var canPersist = sessionStorageAvailable();
    var chosen = canPersist ? window.sessionStorage.getItem(STORAGE_KEY) : null;
    // Guard against a stale value left over from a theme edit that removed it from the pool.
    if (chosen && pool.indexOf(chosen) === -1) chosen = null;

    if (!chosen) {
      chosen = pool[Math.floor(Math.random() * pool.length)];
      if (canPersist) {
        try { window.sessionStorage.setItem(STORAGE_KEY, chosen); } catch (e) {}
      }
    }

    renderMessage(textEl, chosen);
  }

  document.querySelectorAll('[id^="ww-conv-boost-"]').forEach(initBoost);
})();
